// Generated by CoffeeScript 1.12.7
module.exports = function(findModule, populateDI) {
  var addParent;
  return addParent = function(di, base, parentSpec, childCallers) {
    var callers, conf, configFile, nodeModule, ref;
    configFile = parentSpec.configFile, nodeModule = parentSpec.nodeModule;
    callers = childCallers.concat(nodeModule);
    conf = findModule(base, configFile, callers);
    if ((ref = conf.parents) != null) {
      ref.forEach(function(p) {
        return addParent(di, base, p, callers);
      });
    }
    return populateDI(di, base, conf.modules, callers);
  };
};
